import { FC } from 'react';
import MemberReview from 'containers/accounting/pay-runs/MemberReview';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { useAppSelector } from 'hooks';
import { selectIsActionsBlocked } from 'containers/app/appSlice';

const MemberReviewPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  return isActionsBlocked ? <MerchantOrTeamBlockedInfo title="Member Review" /> : <MemberReview />;
};

export default MemberReviewPage;
